var __vueify_style_dispose__ = require("vueify/lib/insert-css").insert("#orangeCardProcessingModal .modal-body[data-v-05296640] {\n  height: 65vh;\n  overflow-y: auto;\n}\n\n#orange_card_page[data-v-05296640] {\n  position: absolute;\n  height: 100%;\n  width: 94.4%;\n  border: none;\n}")
;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "cards",
  props: ["status_api_url", "invoice_no", "callback_url"],
  data: function data() {
    return {
      mpgs_url: null,
      currency: null,
      logo: null,
      invoice_amount: 0,
      agent_fee: 0,
      fee: 0,
      total_amount: 0,
      bill_ref: null,
      service_id: null,
      loaded: false,
      has_error: false,
      iframe_loading: false,
      gateway_id: null,
      base_url: ""
    };
  },


  mounted: function mounted() {
    var _this = this;

    $("#orangeMoneyProcessingModal").on("shown.bs.modal", function () {});

    $("#orangeCardProcessingModal").on("shown.bs.modal", function () {});

    $("#orangeCardProcessingModal").on("hidden.bs.modal", function () {
      var ifr = window.top.$("#card_page");
      ifr.attr("src", "about:blank");
      _this.mpgs_url = null;
      _this.$refs.timer.destroyTimer();
    });

    $("#orangeMoneyProcessingModal").on("hidden.bs.modal", function () {
      _this.mpgs_url = null;
    });
    this.mpgs_url = this.$attrs["mpgs_api_url"];
    this.invoice_amount = this.$attrs["amount_net"];
    this.currency = this.$attrs["currency"];
    this.fee = this.$attrs["fee"];
    this.agent_fee = this.$attrs["agent_fee"];
    this.logo = this.$attrs["logo"];
    this.bill_ref = this.$attrs["bill_ref"];
    this.service_id = this.$attrs["service_id"];
    this.gateway_id = this.$attrs["gid"];
    this.base_url = this.$attrs["base_url"];
    this.set_total_amount();
  },
  methods: {
    load_iframe: function load_iframe() {
      $("#orangeMoneyProcessingModal .close").click();
      $("#orangeCardProcessingModal").modal("show");
    },

    ensure_closed: function ensure_closed() {
      $("#orangecardProcessingModal").modal("hide");
      $("#orangecardProcessingModal .close").click();
    },


    getPaymentUrl: function getPaymentUrl() {
      var _this2 = this;

      this.iframe_loading = true;
      var url = this.base_url + "/api/payment/orange/checkout";
      var payload = {
        invoice_number: this.invoice_no,
        amount: this.total_amount,
        return_url: this.callback_url,
        gateway_id: this.gateway_id
      };
      Vue.axios.post(url, payload).then(function (response) {
        _this2.mpgs_url = response.data.payment_url;
        _this2.loaded = true;
        window.top.location.href = _this2.mpgs_url;
      }).catch(function (error) {
        _this2.has_error = true;
        _this2.iframe_loading = false;
      }).then(function () {
        _this2.iframe_loading = false;
      });
    },

    getOauthToken: function getOauthToken() {
      var _this3 = this;

      var url = this.base_url + "/api/oauth/generate/token";
      var payload = {
        secret: this.consumer_secret,
        key: this.consumer_key
      };
      Vue.axios.post(url, payload).then(function (response) {
        _this3.api_token = response.data.token;
      }).catch(function (error) {}).then(function () {});
    },

    set_total_amount: function set_total_amount() {
      this.total_amount = Math.ceil(parseFloat(this.invoice_amount) + parseFloat(this.fee) + parseFloat(this.agent_fee));
    },

    destroy: function destroy(e) {
      $("#cardProcessingModal").modal("hide");
      this.$refs.timer.destroyTimer();
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',{staticClass:"modal fade",attrs:{"id":"orangeCardProcessingModal","aria-labelledby":"orangeCardProcessingModal","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-lg modal-dialog-centered"},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[(_vm.iframe_loading)?_c('span',[_vm._v("Loading , please wait ....")]):_vm._e(),_vm._v(" "),(_vm.iframe_loading)?_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"spinner-border ms-auto",attrs:{"role":"status","aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"\n                card-footer\n                d-flex\n                justify-content-end\n                align-items-center\n              ",attrs:{"id":"option_buttons"}},[_c('complete-button',{ref:"timer",attrs:{"gateway":"cards","status_api_url":_vm.status_api_url,"invoice_no":_vm.invoice_no,"callback_url":_vm.callback_url},on:{"click":_vm.destroy}}),_vm._v(" "),_c('a',{staticClass:"btn btn-link text-dark px-5",attrs:{"href":"#","data-dismiss":"modal"}},[_vm._v("Close")])],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"orangeMoneyProcessingModal","tabindex":"-1","role":"dialog","aria-labelledby":"orangeMoneyProcessingModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-full",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"modal-body d-flex align-items-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 mx-auto"},[_c('img',{staticClass:"navbar-brand-img",attrs:{"src":_vm.logo,"alt":"..."}}),_vm._v(" "),_c('form',{ref:"orangesform",attrs:{"action":_vm.mpgs_url,"method":"GET","target":"orange_card_page"}},[_c('div',{staticClass:"card mt-3"},[_c('div',{staticClass:"card-header d-flex justify-content-between"},[_c('p',{staticClass:"mb-0"},[_vm._v("Pay using OrangeMoney")]),_vm._v(" "),_c('p',{staticClass:"mb-0 lead"},[_vm._v("\n                        "+_vm._s(_vm.currency)+" "+_vm._s(_vm.total_amount)+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"card-header d-flex justify-content-between"},[_c('p',{staticClass:"mb-0"},[_vm._v("Total Due*")]),_vm._v(" "),_c('p',{staticClass:"mb-0 lead"},[_vm._v("\n                        "+_vm._s(_vm.currency)+" "+_vm._s(_vm.total_amount)+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"\n                        card-footer\n                        d-flex\n                        justify-content-end\n                        align-items-center\n                      "},[_c('a',{staticClass:"btn btn-link text-dark px-5",attrs:{"href":"#","data-dismiss":"modal"},on:{"click":function($event){_vm.ensure_closed()}}},[_vm._v("Cancel")]),_vm._v(" "),(!_vm.iframe_loading)?_c('input',{staticClass:"btn btn-primary",attrs:{"type":"button","data-toggle":"modal","value":"Proceed to pay","data-target":".orangecardProcessingModal"},on:{"click":_vm.getPaymentUrl}}):_vm._e(),_vm._v(" "),(_vm.iframe_loading)?_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":""}},[_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status","aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"visually-hidden"},[_vm._v("One moment...")])]):_vm._e()])])])])])])])])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h3',{staticClass:"modal-title"},[_vm._v("Authorise Payment")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticStyle:{"background":"#fff"},attrs:{"id":"orange_card_page","width":"80%","height":"100%","name":"orange_card_page","frameborder":"0"}})])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header d-flex align-items-center"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{staticClass:"fe fe-x text-dark",attrs:{"aria-hidden":"true"}})])])}]
__vue__options__._scopeId = "data-v-05296640"
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  module.hot.dispose(__vueify_style_dispose__)
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-05296640", __vue__options__)
  } else {
    hotAPI.reload("data-v-05296640", __vue__options__)
  }
})()}